"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

var re = /(?:\r\n|\r|\n)/g;
var themeSettings = {
  name: 'SxMultilineText'
};
var useStyles = (0, _styles.makeStyles)({
  root: {},
  paragraph: {
    display: 'block',
    marginTop: '1em',
    marginBottom: '1em',
    marginLeft: 0,
    marginRight: 0
  }
}, themeSettings);
/**
 * Pokud je `children` typu `string` upravy jej pro zobrazeni ve vice radcich. Jine typy `children` renderuje
 * beze zmeny.
 *
 * @component
 */

var MultilineText = function MultilineText(_ref) {
  var children = _ref.children,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'span' : _ref$component;
  var classes = useStyles();
  return typeof children === 'string' && re.test(children) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children.split(re).map(function (item, key) {
    return /*#__PURE__*/_react.default.createElement(Component, {
      key: key.toString(),
      className: classes.paragraph
    }, item);
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};

process.env.NODE_ENV !== "production" ? MultilineText.propTypes = {
  children: _propTypes.default.node,
  component: _propTypes.default.node
} : void 0;
MultilineText.displayName = 'MultilineText';

var _default = (0, _withThemeProps.default)(themeSettings)(MultilineText);

exports.default = _default;